
import { Link } from "react-router-dom";
import { ExternalLink, Mail } from "lucide-react";
import { getCachedLogoUrl, FOOTER_LOGO_FILENAME } from "@/utils/logoUrlHelper";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerLogoUrl = getCachedLogoUrl(FOOTER_LOGO_FILENAME);
  
  return (
    <footer className="bg-[#031029] text-white border-t border-gray-800 mt-10">
      <div className="container py-8 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1 flex justify-center items-start">
            <img
              src={footerLogoUrl}
              alt="LamuLamu Fish Logo"
              width={128}
              height={98}
              className="h-[98px] w-[128px] object-contain"
              onError={(e) => {
                console.error('[Footer] Image failed to load:', footerLogoUrl);
                e.currentTarget.src = '/lovable-uploads/fish-footer.png';
              }}
            />
          </div>
          
          <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <Link to="/about-us" className="font-semibold text-lg hover:text-primary">
                <h3>About Us</h3>
              </Link>
              <p className="text-sm text-gray-300">
                We connect customers with trusted local service providers across Kenya.
              </p>
            </div>
            
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">Contact</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-gray-300">
                  <Mail className="w-4 h-4" />
                  <span>info@lamulamu.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {currentYear} Services Directory. All rights reserved.
          </p>
          <div className="flex items-center gap-4 mt-4 md:mt-0">
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-primary"
            >
              <div className="flex items-center gap-1 text-sm">
                Twitter <ExternalLink className="w-3 h-3" />
              </div>
            </a>
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-primary"
            >
              <div className="flex items-center gap-1 text-sm">
                Facebook <ExternalLink className="w-3 h-3" />
              </div>
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-primary"
            >
              <div className="flex items-center gap-1 text-sm">
                Instagram <ExternalLink className="w-3 h-3" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
